import React, { useCallback, useEffect, useState } from "react";
import { getAboutSecretariat } from "../../api/about";
import Container from "../../components/Container";
import ImageWithTooltip from "../../components/ImageWithTooltip";
import MainCard from "../../components/MainCard";
import PageContainer from "../../components/PageContainer";

const bgImg = "/images/hero-image.jpeg";

const Secretariat = () => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutSecretariat()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer bgImg={bgImg} title="เกี่ยวกับสำนักงาน">
      <Container isAlignTop>
        <MainCard>
          <div className="header-content">
            <h2 className="header-content__title">{pageData?.title}</h2>
          </div>
          {pageData?.people?.map((person) => {
            return (
              <div className="bg-white relative p-6 rounded-lg drop-shadow-md border border-[#E5E5EF] mb-4">
                <img
                  className="absolute bottom-0 right-0 z-0 opacity-50 md:opacity-100"
                  src="/images/bg-executive.png"
                  alt=""
                  role="presentation"
                />
                <div className="flex flex-auto flex-wrap relative">
                  <div className="w-full md:w-[30%]">
                    <ImageWithTooltip
                      className="aspect-[4/6] w-full object-cover rounded-lg"
                      src={person?.image?.path}
                      alt={person.image.altText}
                    />
                  </div>
                  <div className="w-full md:w-[70%]">
                    <div className="w-full h-full flex items-center py-4 md:px-12">
                      <div className="md:border-l-2 border-[var(--base-color)] py-4 md:px-10 md:py-8">
                        <div className="bg-[#EEEEEE] py-2 px-4 inline-block">
                          <h3 className="text-[var(--base-color)] text-3xl font-semibold">
                            {person?.name}
                          </h3>
                        </div>
                        <div className="text-xl text-[#B3B4B4] text-center md:text-left font-medium py-4">
                          <p>{person?.term}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default Secretariat;
